import { createSlice } from '@reduxjs/toolkit';
import {
  fetchDashboardCounts,
  fetchShellDashboard,
  fetchBoggieDashboard,
  fetchWheelDashboard,
  fetchFurnishingDashboard,
} from './dashboardThunk';

const initialState = {
  data: [],
  loading: false,
  error: null,
  shellDashboard: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },

  boggieDashboard: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },

  wheelDashboard: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },

  furnishingDashboard: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
};

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    resetDashboard: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboardCounts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDashboardCounts.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
      })
      .addCase(fetchDashboardCounts.rejected, (state, action) => {
        state.data = null;
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(fetchShellDashboard.pending, (state) => {
        state.shellDashboard.loading = true;
        state.shellDashboard.error = null;
      })
      .addCase(fetchShellDashboard.fulfilled, (state, action) => {
        state.shellDashboard.loading = false;
        state.shellDashboard.data = action.payload.data;
      })
      .addCase(fetchShellDashboard.rejected, (state, action) => {
        state.shellDashboard.loading = false;
        state.shellDashboard.error = action.payload;
      })

      .addCase(fetchWheelDashboard.pending, (state) => {
        state.wheelDashboard.loading = true;
        state.wheelDashboard.error = null;
      })
      .addCase(fetchWheelDashboard.fulfilled, (state, action) => {
        state.wheelDashboard.loading = false;
        state.wheelDashboard.data = action.payload.data;
      })
      .addCase(fetchWheelDashboard.rejected, (state, action) => {
        state.wheelDashboard.loading = false;
        state.wheelDashboard.error = action.payload;
      })

      .addCase(fetchBoggieDashboard.pending, (state) => {
        state.boggieDashboard.loading = true;
        state.boggieDashboard.error = null;
      })
      .addCase(fetchBoggieDashboard.fulfilled, (state, action) => {
        state.boggieDashboard.loading = false;
        state.boggieDashboard.data = action.payload.data;
      })
      .addCase(fetchBoggieDashboard.rejected, (state, action) => {
        state.boggieDashboard.loading = false;
        state.boggieDashboard.error = action.payload;
      })
      .addCase(fetchFurnishingDashboard.pending, (state) => {
        state.furnishingDashboard.loading = true;
        state.furnishingDashboard.error = null;
      })
      .addCase(fetchFurnishingDashboard.fulfilled, (state, action) => {
        state.furnishingDashboard.loading = false;
        state.furnishingDashboard.data = action.payload.data;
      })
      .addCase(fetchFurnishingDashboard.rejected, (state, action) => {
        state.furnishingDashboard.loading = false;
        state.furnishingDashboard.error = action.payload;
      });
  },
});
export const { resetDashboard } = dashboardSlice.actions;
export default dashboardSlice.reducer;
